
import i18n from '@/i18n';
export enum ExceptionTypeEnum {
  None = 0,
  Total = 1,
  Backend = 2,
  Mobile = 4,
  NoLaunch = 8,
  Custom = 16
}

export const EXCEPTION_TYPE_OPTIONS = [
  { value: '', label: i18n.t('所有') },
  { value: ExceptionTypeEnum.None, label: i18n.t('无异常') },
  { value: ExceptionTypeEnum.Total, label: i18n.t('总流量异常') },
  { value: ExceptionTypeEnum.Backend, label: i18n.t('后台流量异常') },
  { value: ExceptionTypeEnum.Mobile, label: i18n.t('移动流量异常') },
  { value: ExceptionTypeEnum.NoLaunch, label: i18n.t('没启动流量过大') },
  { value: ExceptionTypeEnum.Custom, label: i18n.t('自定义场景流量过大') },
];
// 告警使用
export const ALERT_EXCEPTION_TYPE_OPTIONS = [
  { value: ExceptionTypeEnum.None, label: i18n.t('无异常') },
  { value: ExceptionTypeEnum.Total, label: i18n.t('总流量异常') },
  { value: ExceptionTypeEnum.Backend, label: i18n.t('后台流量异常') },
  { value: ExceptionTypeEnum.Mobile, label: i18n.t('移动流量异常') },
  { value: ExceptionTypeEnum.NoLaunch, label: i18n.t('没启动流量过大') },
  { value: ExceptionTypeEnum.Custom, label: i18n.t('自定义场景流量过大') },
];

export const EXCEPTION_TYPE_SORT = [i18n.t('总流量异常'), i18n.t('后台流量异常'), i18n.t('移动流量异常'), i18n.t('没启动流量过大'), i18n.t('自定义场景流量过大')];
